import { type IconProps } from './types'
/**
 * ![Zygouxuan](data:image/svg+xml;base64,PHN2ZyB0PSIxNzQ1NDkwNjIzOTY3IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjExMjc0IiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiPjxwYXRoIGQ9Ik03ODAuNDE2IDI2Ni4yNGE0MS42IDQxLjYgMCAwIDEgNjMuMjMyIDUzLjc2bC00LjQxNiA1LjEyLTM5OC40NjQgMzk4LjA4YTQxLjYgNDEuNiAwIDAgMS01My42MzIgNC40OGwtNS4xMi00LjQ4LTIyNi42ODgtMjI2LjE3NmE0MS42IDQxLjYgMCAwIDEgNTMuNTY4LTYzLjI5Nmw1LjE4NCA0LjQxNiAxOTcuMjQ4IDE5Ni44NjQgMzY5LjA4OC0zNjguNzA0eiIgcC1pZD0iMTEyNzUiPjwvcGF0aD48L3N2Zz4=)
 */
export const ZygouxuanIcon = ({ color = 'currentColor', size = 16, ...props }: IconProps) => {
  return (
    <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width={size} height={size} {...props}>
      <path
        d="M780.416 266.24a41.6 41.6 0 0 1 63.232 53.76l-4.416 5.12-398.464 398.08a41.6 41.6 0 0 1-53.632 4.48l-5.12-4.48-226.688-226.176a41.6 41.6 0 0 1 53.568-63.296l5.184 4.416 197.248 196.864 369.088-368.704z"
        fill={color}
      ></path>
    </svg>
  )
}
